<template>
    <modal :id="modalId" title="Confirm Changes" ok-title="Proceed" @ok.prevent="verify">
        This action will approve the guest ID in it's current form.
    </modal>
</template>

<script>
    import modal from '../../generic/modal/modal.vue';

    export default {
        components: { modal },
        props: {
            modalId: {
                type: String,
                default: '',
            },
            verify: {
                type: Function,
                default: () => {},
            },
        },
    };
</script>

<style></style>
